import { z } from 'zod';
export const packetCreateSchema = z.object({
    name: z.string().min(1).max(200),
    description: z.string().max(2000).nullish(),
    // Ordered form membership — array order defines position.
    formIds: z.array(z.string().uuid()).max(100).optional(),
});
export const packetUpdateSchema = packetCreateSchema.partial();
// Reorder / replace membership: the new ordered list of form ids.
export const packetReorderSchema = z.object({
    formIds: z.array(z.string().uuid()).min(1).max(100),
});
//# sourceMappingURL=packets.js.map